import {
  FileText,
  FileImage,
  FileArchive,
  FileVideo,
  FileAudio,
} from "lucide-react";

/** Choose a lucide icon component that best represents a mime type. */
export function iconFor(mime) {
  if (!mime) return FileText;
  if (mime.startsWith("image/")) return FileImage;
  if (mime.startsWith("video/")) return FileVideo;
  if (mime.startsWith("audio/")) return FileAudio;
  if (mime.includes("zip") || mime.includes("compressed")) return FileArchive;
  return FileText;
}

export function formatSize(bytes) {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Return the best preview strategy for a mime type.
 * - "image": render <img> in-modal
 * - "pdf":   render <iframe> in-modal
 * - "video": render <video controls> in-modal
 * - "audio": render <audio controls> in-modal
 * - "text":  render plaintext in-modal (small files only)
 * - "none":  show a "download" fallback
 */
export function previewKindFor(mime, size) {
  if (!mime) return "none";
  if (mime.startsWith("image/")) return "image";
  if (mime === "application/pdf") return "pdf";
  if (mime.startsWith("video/")) return "video";
  if (mime.startsWith("audio/")) return "audio";
  if (mime.startsWith("text/") && (size == null || size < 512 * 1024))
    return "text";
  return "none";
}
